var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentLibraryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2629_1518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.9998V3.33317C0 1.8625 1.196 0.666504 2.66667 0.666504H4C4.30933 0.666504 4.61867 0.739171 4.89467 0.877171L6.998 1.92917C7.09 1.97517 7.19333 1.99917 7.296 1.99917H10.6667C12.5047 1.99917 14 3.4945 14 5.3325H6.68267C4.924 5.3325 3.34733 6.50984 2.84667 8.20117L1.06467 14.4272C0.413333 13.8185 0 12.9592 0 11.9998ZM15.662 7.3445C15.3427 6.91584 14.856 6.66984 14.3233 6.66117C14.3133 6.66117 14.3053 6.6665 14.2953 6.6665H6.68267C5.51067 6.6665 4.45933 7.45117 4.12667 8.5745L2.248 15.1365C2.59 15.2552 2.95133 15.3332 3.33333 15.3332H11.7053C13.1893 15.3332 14.472 14.3785 14.9067 12.9285L15.928 8.85117C16.084 8.32984 15.9867 7.78117 15.662 7.3445Z",
    fill: "#0075FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2629_1518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLibraryIcon);
export default __webpack_public_path__ + "static/media/ContentLibraryIcon.a4373b553d3876a466193c76e3bf5e9a.svg";
export { ForwardRef as ReactComponent };